import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import * as Sentry from "@sentry/browser";

if (process.env.REACT_APP_SENTRY_DSN && process.env.REACT_APP_SENTRY_ENABLED === "true") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    tracePropagationTargets: [
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      "localhost",
      /^https:\/\/(.*)\.ngrok-free\.app/, // local testing on ngrok
      /^https:\/\/(.*)\.designbysweet.com/, // includes local and cloud environments
    ],
    integrations: [
      /*new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),*/
      Sentry.feedbackIntegration({
        colorScheme: "system",
      }),
    ],
    environment: process.env.REACT_APP_ENVIRONMENT,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const container = document.getElementById("root");

// Prevent Live Updates from reloading, because we have our own update mechanism
localStorage.shouldBlockReload = true;

const root = createRoot(container!);
root.render(<App tab="home" />);
